/**
 * Run Tab - Network Execution Interface
 * Dynamic UI based on network interface configuration
 */
import React from 'react';
import RunnerView from './runner/RunnerView.jsx';

export default function RunTab({ network }) {
  const { interface: iface, runtimeConfig, status } = network;

  // ACTIVE (legacy deployed) or RELEASED (versioned snapshot for agentic rooms)
  const st = (status || '').toString().toUpperCase();
  if (st !== 'ACTIVE' && st !== 'RELEASED') {
    console.log('RunTab - Status check failed. Expected ACTIVE or RELEASED, got:', status);
    return (
      <div className="h-full flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            Network Not Ready to Run
          </h2>
          <p className="text-gray-600 mb-4">
            Deploy successfully from the Build tab (or use a released network from Agentic Networks).
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-700 rounded-lg text-sm">
            <span>💡</span>
            <span>Switch to Build tab to continue</span>
          </div>
        </div>
      </div>
    );
  }

  if (!iface || !runtimeConfig) {
    return (
      <div className="h-full flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            Missing Configuration
          </h2>
          <p className="text-gray-600">
            This network is missing interface or runtime configuration. Try redeploying it.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full min-h-0 overflow-hidden flex flex-col">
      <RunnerView
        network={network}
        interface={iface}
        runtimeConfig={runtimeConfig}
      />
    </div>
  );
}
